import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const ChevronDown = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.8543 5.571C13.0614 5.79734 13.0459 6.14875 12.8195 6.35591L8.38233 10.4171C8.09667 10.6786 7.65694 10.6728 7.37818 10.404L3.16992 6.346C2.94906 6.13302 2.94267 5.78132 3.15564 5.56046C3.36862 5.33959 3.72032 5.3332 3.94119 5.54618L7.89397 9.35783L12.0694 5.53627C12.2957 5.32912 12.6471 5.34467 12.8543 5.571Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default ChevronDown;
